
/* injects from baggage-loader */

'use strict';

export default class ProjectInvestmentWizardStep3Controller {

	constructor($log, InvestmentWizard) {
		'ngInject';

		this.$log = $log;
		this.InvestmentWizard = InvestmentWizard;

		this.disclosureDoc = {};

		this.signatureAgreements = [{
			id: 'documentSignAgreement',
			text: 'By typing my name here I am signing the Investment Agreement, the Company\'s Operating Agreement and W-9'
		}];

		// Setup agreements
		if (typeof this.InvestmentWizard.investment.signatureAgreements === 'undefined') {
			this.InvestmentWizard.investment.signatureAgreements = this.signatureAgreements;
		}


	}

	$onInit() {

		// Setup the disclosure doc
		this.disclosureDoc = this.InvestmentWizard.project.get('disclosure_doc');

	}


	/**
	 * Called when an signature agreement box is checked
	 * @param {Object} agreement 
	 */
	agreementChecked(agreement) {

		// Record timestamp of agreement check
		agreement.ts = agreement.checked ? new Date() : undefined;

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/step3/projectinvestmentwizard.step3.controller.js